<template>
    <DialogueAnalysis />
</template>

<script>
import DialogueAnalysis from '@/page/dialogueAnalysis.vue';

export default {
    name: 'WorkBadgeDialogueAnalysis',
    components: {
        DialogueAnalysis
    }
};
</script>
